<template>
  <div>
    <VideoDialog v-model="dialog" :title="$t('about.video')"
      video-url="https://www.youtube.com/embed/OqBJfeWRuvI?si=1RowSkG8NBQymrOK" />
    <div class="video-header mb-4">
      <v-icon color="primary" class="me-2">mdi-play-circle</v-icon>
      <h4 class="text-h5 font-weight-bold primary--text d-inline">
        {{ $t("about.video") }}
      </h4>
    </div>
    <div v-ripple @click="handleVideoOpen" @keydown.enter="handleVideoOpen" class="video-container elevation-4"
      tabindex="0" role="button" :aria-label="$t('about.video')">
      <media-card title="استكشف مع متنامي - حلول رقمية مبتكرة لعصر التكنولوجيا" orientation="landscape" type="video"
        thumb="/images/cover.png" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "./about-style.scss";

.video-header {
  display: flex;
  align-items: center;
}

.video-container {
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 16px 48px rgba(63, 81, 181, 0.25) !important;
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(63, 81, 181, 0.3) !important;
  }
}

@media (max-width: 600px) {
  .video-container {
    &:hover {
      transform: scale(1.01);
    }
  }
}
</style>

<script>
import MediaCard from "../Cards/MediaCard";
import VideoDialog from "../VideoDialog.vue";

export default {
  components: {
    MediaCard,
    VideoDialog
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    handleVideoOpen() {
      this.dialog = true;
    }
  }
};
</script>
